module.exports = __webpack_public_path__ + "telescope.jpg?e05e8e8ac3d236ce743335dd200f60ae";